import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { studentAPI } from '@/lib/api';
import { toast } from 'sonner';

// A parent's on/off switch for one setting on a child's record. The server enforces it, so a child
// cannot get around it from their own screen.
const ParentSwitch = ({ studentId, field, title, help, onMessage, offMessage, testId }) => {
  const qc = useQueryClient();
  const { data: student } = useQuery({
    queryKey: ['student', studentId],
    queryFn: async () => (await studentAPI.getById(studentId)).data,
  });
  const mut = useMutation({
    mutationFn: (value) => studentAPI.update(studentId, { [field]: value }),
    onSuccess: (_res, value) => {
      qc.invalidateQueries({ queryKey: ['student', studentId] });
      toast.success(value ? onMessage : offMessage);
    },
    onError: (e) => toast.error(e?.response?.data?.detail || 'Could not save'),
  });
  return (
    <div className="border-2 border-black p-4 bg-white" data-testid={testId}>
      <label className="flex items-start gap-3 cursor-pointer">
        <input type="checkbox" className="mt-1 w-5 h-5" checked={!!student?.[field]} disabled={!student || mut.isPending}
          onChange={(e) => mut.mutate(e.target.checked)} />
        <span>
          <span className="block font-black uppercase text-sm">{title}</span>
          <span className="block text-xs text-gray-600">{help}</span>
        </span>
      </label>
    </div>
  );
};

export default ParentSwitch;
